export const calculateNumberOfPages = ({
  numberOfItems,
  pageSize,
}: {
  numberOfItems: number;
  pageSize: number;
}) => {
  // Default to first page if invalid data
  if (!numberOfItems || !pageSize) {
    return 1;
  }
  return Math.ceil(numberOfItems / pageSize);
};

export const getSafePageNumber = ({
  pageNumber,
  numberOfPages,
}: {
  numberOfPages: number;
  pageNumber: number;
}) => {
  // over max
  if (pageNumber > numberOfPages) {
    return numberOfPages;
  }
  // under min
  if (pageNumber < 1) {
    return 1;
  }
  // valid number
  return pageNumber;
};

export const getPageItems = <T>({
  items,
  pageSize,
  pageNumber,
}: {
  items: T[] | undefined;
  pageSize: number;
  pageNumber: number;
}) => {
  if (!items || !pageSize || !pageNumber) {
    return null;
  }

  const startIndex = (pageNumber - 1) * pageSize; // Inclusive
  const endIndex = pageNumber * pageSize; // Exclusive

  return items.slice(startIndex, endIndex);
};
